import React from 'react';
import { Department } from '../../lib/types';
import { inp, MsgBox } from './shared';

interface Props {
  activeDepts: Department[];
  newDept: string; setNewDept: (s: string) => void;
  deptMsg: string;
  deptBusy: boolean;
  onAdd: () => void;
  onDeactivate: (id: string, name: string) => void;
}

export function SettingsDepartments(p: Props) {
  return (
    <div style={{ animation: 'fadeSlideIn .25s ease-out' }}>
      <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--text)', marginBottom: 4 }}>Departments</div>
      <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 20 }}>Manage departments. Deactivated departments are hidden from dropdowns but preserved for records.</div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 14 }}>
        <input
          value={p.newDept}
          onChange={e => p.setNewDept(e.target.value)}
          placeholder="Department name"
          style={{ ...inp, flex: 1 }}
          onKeyDown={e => { if (e.key === 'Enter') p.onAdd(); }}
        />
        <button className="hbtn acc" disabled={p.deptBusy || !p.newDept.trim()} onClick={p.onAdd}
          style={{ borderRadius: 8, padding: '8px 16px', fontSize: 12, whiteSpace: 'nowrap' }}>+ Add</button>
      </div>
      <MsgBox msg={p.deptMsg} />

      {p.activeDepts.length === 0 ? (
        <div style={{ color: 'var(--text3)', fontSize: 12, padding: '20px 0', textAlign: 'center' }}>No departments yet</div>
      ) : p.activeDepts.map(d => (
        <div key={d.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: '1px solid var(--border)' }}>
          <span style={{ fontSize: 13, fontWeight: 500 }}>{d.name}</span>
          <button onClick={() => p.onDeactivate(d.id, d.name)}
            style={{ background: 'none', border: '1px solid var(--border)', color: 'var(--text3)', padding: '4px 10px', borderRadius: 6, cursor: 'pointer', fontSize: 11, fontFamily: 'var(--font)' }}>
            Deactivate
          </button>
        </div>
      ))}
    </div>
  );
}
